export const environment = {
  production: true,
  mode:{
    dev:false,
    localhost:false,
    prod:true,
    stage:false
  },
  /////
  CURRENT_PATH : 'https://roshdima.com/',
  SHARE_PATH : 'https://roshdima.com/',
  BASE_MEDIA_PATH : 'https://roshdima.com/',
  BASE_DEFALT_IMAGE_PATH : 'https://roshdima.com/assets/image/',
  BASE_API_URL : 'https://roshdima.com/api/',
  QUIZ_API_URL : 'https://roshdima.com/api/quiz/',
};